import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PumpsPage } from './pages/PumpsPage';
import { ExtendYourStepPage } from './pages/ExtendYourStepPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <main className="w-full font-sans text-slate-800 bg-white" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<PumpsPage data-id="element-4" />} data-id="element-3" />
          <Route path="/pumps" element={<PumpsPage data-id="element-6" />} data-id="element-5" />
          <Route path="/extend-your-step" element={<ExtendYourStepPage data-id="element-8" />} data-id="element-7" />
          {/* Fallback: anything unknown goes to the Pumps page */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-10" />} data-id="element-9" />
        </Routes>
      </main>
    </BrowserRouter>;
}